import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/inputs/Button';
import { useExportExportManagementReportHook } from 'api/export/export';
import { downloadBlob } from 'utils/file-utils';
import { formatDate } from 'utils/date-helpers';
import { showException } from 'utils/exception-helper';
import useManagementKpiFilter from './useManagementKpiFilter';

/**
 * Laddar ner hela ledningsrapporten som en Excel-arbetsbok — ett blad per punkt.
 *
 * En knapp för hela rapporten i stället för en per widget: det är den filen som bifogas till
 * RM:s ledningsgrupp, och varje punkt har ändå sitt eget blad. Filen byggs dessutom av ett enda
 * anrop, så bladen kan inte hamna på olika sida om ett godkännande.
 */
const ManagementReportDownloadButton = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { isReady, isDateRangeTooLong, filter, startDate, endDate } =
    useManagementKpiFilter();
  const download = useExportExportManagementReportHook();

  return (
    <Button
      disabled={isDownloading || !isReady}
      title={
        isDateRangeTooLong
          ? 'Datumintervallet är för långt — max 366 dagar per export'
          : undefined
      }
      onClick={async () => {
        if (!startDate || !endDate) return;
        try {
          setIsDownloading(true);
          const result = await download(filter);
          if (result) {
            downloadBlob(
              result,
              `Zakra_Ledningsrapport_${formatDate(startDate)}_${formatDate(endDate)}.xlsx`
            );
          }
        } catch (error) {
          showException(error);
        } finally {
          setIsDownloading(false);
        }
      }}
    >
      <FontAwesomeIcon icon={faDownload} /> Hela rapporten som Excel
      {isDownloading ? (
        <FontAwesomeIcon icon={faSpinner} spin style={{ marginLeft: '5px' }} />
      ) : null}
    </Button>
  );
};

export default ManagementReportDownloadButton;
